import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLFormElement> {
  static readonly values = {
    debounceTime: Number,
  };

  declare readonly debounceTimeValue: number;

  private _debounceTimer?: number;

  async onTriggerDebounce() {
    if (this.element instanceof HTMLFormElement) {
      await this._debounce(this.debounceTimeValue);
      this.element.requestSubmit();
    }
  }

  private _debounce(delay: number) {
    return new Promise<void>((resolve) => {
      clearTimeout(this._debounceTimer);
      this._debounceTimer = setTimeout(() => {
        resolve();
      }, delay);
    });
  }
}
